import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-agency-two-pricing',
  templateUrl: './agency-two-pricing.component.html',
  styleUrls: ['./agency-two-pricing.component.scss']
})
export class AgencyTwoPricingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
